<template>
  <footer
    class="layout-footer"
    data-cy="footer"
  >
    <div
      class="links"
      data-cy="footer-links"
    >
      <div class="content">
        <component
          v-for="link in links"
          :key="link.name"
          class="link"
          :class="link.is_divider_link ? 'link-divider' : ''"
          :href="link.path || null"
          :target="link.external ? '_blank' : ''"
          :is="link.external ? 'a' : 'router-link'"
          :to="link.path"
        >
          {{ link.name }}
        </component>
      </div>
    </div>
    <div class="bottom">
      <div
        class="terms"
        data-cy="footer-terms"
      >
        <router-link
          v-for="term in terms"
          :key="term.name"
          class="term"
          :to="{ name: term.name }"
        >
          {{ term.routeName }}
        </router-link>
      </div>
      <div
        class="copyright"
        v-if="!hideDeveloped"
      >
        <c-clube-logo
          is-grey
          class="logo"
        />
        <p class="copyright-symbol">
          &copy; {{ new Date().getFullYear() }}
        </p>
      </div>
    </div>
    <c-button
      alternative
      :class="classes"
      size="xl"
      @click="scrollTop"
      icon="chevron-up"
    />
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import * as types from '@store/types'

const TERMS = [
  {
    name: 'Termos do usuário logado',
    routeName: 'Termos do usuário'
  },
  {
    name: 'Termos de parceria logado',
    routeName: 'Termos de parceria'
  },
  {
    name: 'Política de privacidade logado',
    routeName: 'Política de privacidade'
  }
]
export default {
  props: {
    displayScrollTop: Boolean,
    config: Object,
    hideDeveloped: Boolean
  },
  data () {
    return {
      terms: TERMS,
      isBottom: false
    }
  },
  computed: {
    links () {
      return [
        ...(
          this.$can('cashback_tab')
            ? [
              {
                name: 'Dinheiro de volta',
                path: ({
                  name: 'Campanhas',
                  query: { cashback: '1' }
                })
              }
            ] : []
        ),
        ...(
          this.$can('cashback_tab')
            ? [
              {
                name: '|',
                path: '',
                external: false,
                is_divider_link: true
              }
            ] : []
        ),
        {
          name: 'Suporte',
          path: (this.config && this.config.support_link) || 'https://kaledo.zendesk.com/hc/pt-br',
          external: true
        }
      ]
    },
    classes () {
      const classes = [
        'top', {
          '-shown-home': this.displayScrollTop && this.$route.name === 'Home',
          '-shown-details': this.displayScrollTop && this.$route.name === 'Detalhes da campanha',
          '-is-bottom-home': this.isBottom && this.$route.name === 'Home',
          '-is-bottom-details': this.isBottom && this.$route.name === 'Detalhes da campanha'
        }]
      return classes
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollTop () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    handleScroll: function (e) {
      const totalSize = window.innerHeight + window.scrollY + 1

      if (totalSize >= document.body.scrollHeight) {
        this.isBottom = true
      } else {
        this.isBottom = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.layout-footer {
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 16px;

  .links {
    background-color: rgba($base-color, 0.1);
    padding: 20px;
    display: flex;
    flex-flow: row nowrap;

    & > .content {
      @include container;

      width: 100%;

      & > .link {
        color: var(--color-primary);
        text-decoration: none;
        font-size: 12px;
        position: relative;

        &:not(:last-of-type) {
          margin-right: 10px;
        }
      }

      & > .link-divider {
        font-size: 15px;
      }
    }
  }

  & > .bottom {
    @include container;
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;

    @include mobile {
      flex-direction: column;
      padding-left: 20px;
      padding-right: 20px;
    }

    & > .terms {
      padding-top: 20px;
      padding-bottom: 20px;

      & > .term {
        color: $text-color;
        text-decoration: none;
        font-size: 11px;
        position: relative;
        display: inline-block;

        &:not(:last-of-type) {
          margin-right: 32px;

          &::after {
            content: '';
            position: absolute;
            right: -18px;
            top: 50%;
            transform: translateY(-50%);
            height: 4px;
            width: 4px;
            border-radius: 100%;
            background-color: $secondary-color-placeholder;
            background-color: var(--color-secondary);
          }
        }
      }
    }

    & > .copyright {
      color: rgba(17.85, 30.6, 71.4, 0.5);
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      line-height: 17px;

      @include mobile {
        padding-top: 20px;
        padding-bottom: 20px;
        border-top: 1px solid $border-color;
      }

      & > .logo {
        margin-right: 7px;
        width: 70px;
      }

      & > .copyright-symbol {
        font-size: 11px;
        margin-top: 4px;
      }
    }
  }

  & > .top.c-button {
    position: fixed;
    right: 20px;
    bottom: -48px;
    transition: bottom 0.3s ease, background-color .3s ease;

    &.-shown-home { bottom: 20px; z-index: 5; }
    &.-shown-details { bottom: 70px; z-index: 5; }
    &.-is-bottom-home { bottom: 125px; }
    &.-is-bottom-details { bottom: 70px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/LayoutFooter.vue